<template>
  <header id="header" class="ly_header">
      <div class="bl_header_inner ly_header_inner">
          <router-link to="/">
            <h1>
                <span class="bl_header_inner_icon"></span>
                <div class="bl_header_inner_title ly_header_inner_title">
                    <span>平成28年省エネルギー基準（住宅／非住宅）</span>
                    <span>日よけ効果係数算出ツール</span>
                    <span class="version">{{ this.version }}</span>
                </div>
            </h1>
          </router-link>
          <div class="uq_button_container">
            <app-button
                v-if="isComfirmed"
                @click="toResult"
                :disabled="!getAll.calculated"
                class="toresult"
                name="計算結果の確認"
            />
            <app-button
                v-if="isComfirmed"
                name="計算する"
                @click="calculate"
                class="btn_calc"
            />
          </div>
    </div>
    <div class="white_box">
        <span
        v-if="foldIsShow"
        @click="toggleMenu"
        class="btn_menu"
        >
        = 閉じる =
        </span>
        <span
        v-else
        @click="toggleMenu"
        class="btn_menu"
        >
        = メニュー =
        </span>
    </div>
  </header>
</template>


<script>
/**
 * 共通ヘッダ
 * 
 * [プロパティ]
 * 
 * [算出プロパティ]
 * 
 * [イベント処理]
 * 
 * [利用例]
 * <layout-header
 * />
 * 
 * [データ]
 */
import AppButton from '@/components/atoms/AppButton'
import { mapActions, mapGetters} from 'vuex'
import axios from "axios"

export default {
    name:"LayoutHeader",
    data(){
        return {
            /**
             * バージョン番号
             */
            version: null,
            foldIsShow: false
        }
    },
    components:{
        AppButton
    },
    props: {
    },
    computed:{
        ...mapGetters(['getAll']),
       /**
       * 承諾画面の後のページか否か判定
       */
      isComfirmed(){
        if(this.$route.name !== "index"){
          return true
        } else {
          return false
        }
      },
    },
    methods: {
        ...mapActions(['calc']),
        calculate(){
            this.calc()
                .then(response => {
                    console.log(response)
                    if(response.status == 200 && response.data.Status == "OK") {
                        this.toResult()
                    }
                })
        },
        toResult(){
            this.$router.push('/result')
        },
        /**
         * ハンバーガーメニューを表示切り替え
         */
        toggleMenu(){
            this.foldIsShow = !this.foldIsShow
        }
    },
    mounted() {
      axios
        .get('/api/version')
        .then(response => (this.version = response.data))
    }    
}
</script>

<style lang="scss" scoped>
.ly_header{
    display: flex;
    flex-direction: column;
    min-width: 100%;
    height: 55px;
    background-color: #53BFD8;
    position: absolute;
}
.ly_header_inner{
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1000px;
    height: 55px;
    margin-right: auto;
    margin-left: auto;
    padding-right: 16px;
    padding-left: 16px;
}
.ly_header_inner h1{
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 8px 0;
    font-size: 22px;
    letter-spacing: 0.05em;
    font-weight: 500;
    color: white;
}
.bl_header_inner h1 .bl_header_inner_icon{
    content: "";
    display: inline-block;
    width: 60px;
    height: 45px;
    margin-top: 0;
    color: transparent;
    background-image: url(/img/all_img.png);
    background-repeat: no-repeat;
    background-size: auto 485px;
    background-position-x: -500px;
}
.ly_header_inner_title{
    display: inline-flex;
    align-items: center;
}
.ly_header_inner h1 span{
    display: inline-block;
    font-size: 14px;
    line-height: 14px;
    margin-top: 4px;
    margin-right: 8px;
    white-space: nowrap;
}
.ly_header_inner h1 span:nth-child(2){
    font-size: 18px;
    line-height: 18px;
}
.ly_header_inner h1 .version{
    display: inline-block;
    margin: 0;
    padding: 2px 12px;
    font-size: 11px;
    font-weight: bolder;
    color: #fff;
    background-color: #0443a8;
    border-radius: 3px;
    letter-spacing: 0;
}
.uq_button_container{
    display: flex;
    align-items: center;
    margin-left: auto;
}
.toresult{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    margin-top: 35px;
    margin-right: 22px;
    margin-left: auto;
    position: relative;
    font-size: 14px;
    font-weight: bolder;
    color: white;
    white-space: nowrap;
    background: url(/img/all_img.png) no-repeat;
    background-size: auto 425px;
    background-position-x: 17.5%;
    background-position-y: 13%;
    cursor: pointer;
}
.toresult:disabled,
.toresult[disabled="true"]{
    opacity: 1;
    color: #ccc;
    background-position-x: 29.5%;
    cursor: default;
    pointer-events: none;
}
.btn_calc{
    display: flex;
    width: 80px;
    min-width: 80px;
    height: 80px;
    margin-bottom: -30px;
    margin-left: -15px;
    font-size: 18px;
    font-weight: bold;
    position:relative;
    color: transparent;
    background: url(/img/all_img.png) no-repeat; /* スプライト呼び出し */
    background-size: auto 345px;
    background-position-x: 41.62%;
    background-position-y: 2.5%;
    background-color: #0443A8;
    border-radius: 50%;
    cursor: pointer;
}
.white_box{
    display: none;
}
/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
    .ly_header{
        height: auto;
        z-index: 990;
        position: fixed;
        top: 0;
    }
    .ly_header_inner{
        display: flex;
        flex-direction: column;
        height: auto;
    }
    .uq_button_container{
        flex-direction: row-reverse;
        width: 100%;
        padding: 16px;
        background-color: white;
    }
    .uq_button_container .toresult{
        background: none;
        background-color: #aaa;
        width: 50%;
        height: 50px;
        margin: 0;
    }
    .uq_button_container .btn_calc{
        display: flex;
        align-items: center;
        justify-content: center;
        content: "計算する";
        background: none;
        color: white;
        background-color: #0443A8;
        width: 50%;
        max-width: 50%;
        height: 50px;
        margin: 0 16px 0 0;
        border-radius: 25px;
    }
    .ly_header_inner h1 .bl_header_inner_title{
        display: inline-flex;
        flex-wrap:wrap;
        flex-direction: row;
        align-items: center;
        font-size: 18px;
        line-height: 20px;
    }
    .bl_header_inner h1 .bl_header_inner_title span{
        margin-top: 0;
    }
    .bl_header_inner h1 .bl_header_inner_title span:first-child{
        display:inline-block;
        font-size: 12px;
        line-height: 12px;
        margin-right: 8px;
    }
    .white_box{
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        background-color: #555;
        border-top-right-radius: 0;
        height: 40px;
        padding: 0;
    }
    .white_box .btn_menu{
        display: inline-block;
        width: 100%;
        text-align: center;
    }
}
</style>